import {
  Box,
  IconButton,
  Input,
  Heading,
  HStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import UuidPreview from "../../UuidPreview";
import RateAmountInput from "../../RateAmountInput";
import { createEmptyPeril } from "../../utils/placementDefaults";

const PeriodPerilsEditor = ({ perils = [], onChange }) => {
  const updatePeril = (perilIndex, field, value) => {
    const updated = [...perils];
    updated[perilIndex] = {
      ...updated[perilIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addPeril = () => {
    onChange([...perils, createEmptyPeril()]);
  };

  const removePeril = (perilIndex) => {
    const updated = [...perils];
    updated.splice(perilIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Perils</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Peril"
          onClick={addPeril}
        />
      </HStack>

      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>ID</Th>
            <Th>Code</Th>
            <Th>Description</Th>
            <Th>Agency Code</Th>
            <Th>Allocation %</Th>
            <Th>Rule Code</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {perils.map((peril, perilIndex) => (
            <Tr key={peril.id}>
              <Td>
                <UuidPreview uuid={peril.id} />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={peril.code || ""}
                  onChange={(e) => updatePeril(perilIndex, "code", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={peril.description || ""}
                  onChange={(e) => updatePeril(perilIndex, "description", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={peril.agencyCode || ""}
                  onChange={(e) => updatePeril(perilIndex, "agencyCode", e.target.value)}
                />
              </Td>
              <Td>
                <RateAmountInput
                  value={peril.allocationPercentage}
                  onChange={(value) => updatePeril(perilIndex, "allocationPercentage", value)}
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={peril.ruleCode || ""}
                  onChange={(e) => updatePeril(perilIndex, "ruleCode", e.target.value)}
                />
              </Td>
              <Td>
                <IconButton
                  size="sm"
                  icon={<HiOutlineTrash />}
                  aria-label="Delete Peril"
                  onClick={() => removePeril(perilIndex)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default PeriodPerilsEditor;
